// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__hIM0N","header":"ClearentDisclaimer_header__Cd9A_","inner":"ClearentDisclaimer_inner__49RMx"};